import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule, DxTextBoxModule } from 'devextreme-angular';
import { TipoService } from '../../../services/formulacion/tipo.service';
import { ProgramaService } from '../../../services/formulacion/programa.service';
import { CategoriaProgService } from '../../../services/formulacion/categoria-prog.service';
import { UtilHelper } from '../../../_helpers/util';
import { SisinService } from '../../../services/formulacion/sisin.service';
declare const toastr: any;

@Component({
  selector: 'app-categoria-programatica',
  templateUrl: './categoria-programatica.component.html',
  styleUrls: [],
  providers: [TipoService, ProgramaService, CategoriaProgService]
})
export class CategoriaProgramaticaComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  tipo_gasto: any[];
  tipo_intervencion: any[];
  programas: any[];
  codSisin: any[];
  descripcinoSisin: string;
  codigoSisin: number;
  codigoPrograma: any;
  dataResourceCP: any[];
  model: any = {
    id: 0,
    codigo: '',
    categoria: '',
    programa: '',
    programa_id: '',
    codigo_sisin_id: '',
    tipo_gasto: '',
    tipo_gasto_id: '',
    tipo_intervencion: '',
    intervencion_id: '',
    orden: '',
    es_vigente:''
  };
  fuenteId: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  sisinVisible: boolean = false;
  state_toogle: boolean = false;
  vigencia: any[];
  formatCP: string = '';
  hasError: any;

  constructor(private _ts: TipoService, private _ps: ProgramaService, private _ss: SisinService, private _cs: CategoriaProgService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.clearErrors();
    this.getCategorias();
    this.getTipoGastos();
    this.getProgramas();
    this.getCodSisin();

  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { codigo: false, categoria: false, tipo_gasto_id: false, intervencion_id: false, orden: false };
  }

  getCategorias() {
    this._cs.getCategoriaProg().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceCP = result.data;
        } else {
          this.dataResourceCP = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  getTipoGastos() {
    this._ts.getTipoGasto().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.tipo_gasto = result.data;
        } else {
          this.tipo_gasto = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  getProgramas() {
    this._ps.getProgramaActivo().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.programas = result.data;
        } else {
          this.programas = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  /**
   * método para listar todos los codigos Sisin
   */
  getCodSisin() {
    this._ss.getSisinActivo().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.codSisin = result.data;
        } else {
          this.codSisin = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  /**
   * método para obtener un codigo sisin por Id
   * @param id 
   */
  getCodigoSisin(id: any) {
    this._ss.getSisinById(id.value).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.codigoSisin = result.data.codigo;
          this.descripcinoSisin = result.data.descripcion;
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  /**
   * metodo para obtener los programas por IdPorgrama y rellenar las categorías programaticas
   * @param id 
   */
  getCategoria(id: any) {
    this._ps.getProgramaById(id.value).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        this.codigoPrograma = result.data.codigo;
        let c = String(this.codigoPrograma);
        if (result.status == 200) {
          if (c.length > 2) {
            if (this.sisinVisible == true) {
              this.model.codigo = this.codigoPrograma + '-' + this.codigoSisin + '-' + '00';
              this.model.categoria = this.descripcinoSisin;
            } else {
              this.formatCP = '000-0000-000';
              this.model.codigo = this.codigoPrograma + '0000';
            }
          }
          else {
            if (this.sisinVisible == true) {
              this.model.codigo = this.codigoPrograma + '-' + this.codigoSisin + '-00';
              this.model.categoria = this.descripcinoSisin;
            } else {
              this.formatCP = '00-0000-000';
              this.model.codigo = this.codigoPrograma + '0000';
            }
          }
        }
      },
      error => {
        console.log('Error', error);
      });

  }


  getTipoIntervencion(id: any) {
    this.sisinVisible = false;
    this.model.codigo_sisin_id = '';
    this.model.codigo = '';
    if (id.value == 2) {
      this.sisinVisible = true;
    }
    this._ts.getTipoIntervencionByTG(id.value).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.tipo_intervencion = result.data;
        } else {
          this.tipo_intervencion = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.categoria = '';
    this.model.programa = '';
    this.model.programa_id = '';
    this.model.tipo_gasto_id = '';
    this.model.intervencion_id = '';
    this.model.codigo_sisin_id = '';
    this.model.codigo = '';
    this.model.orden = '';
    this.state_toogle = false;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.model.codigo = '';
    
    if (data.tipo_gasto_id == 2)
      this.sisinVisible = true;
    else
      this.sisinVisible = false;
   

    this.clearErrors();
    this._ts.getTipoIntervencionByTG(data.tipo_gasto_id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.tipo_intervencion = result.data;
        } else {
          this.tipo_intervencion = [];
        }
      },
      error => {
        console.log('Error', error);
      });

    this.model.id = data.id;
    this.model.categoria = data.categoria;
    this.model.programa_id = data.programa_id;
    this.model.tipo_gasto_id = data.tipo_gasto_id;
    this.model.codigo_sisin_id = data.codigo_sisin_id;
    this.model.intervencion_id = data.intervencion_id;
    this.model.codigo = data.codigo;
    this.model.orden = data.orden;
    this.model.es_vigente = data.es_vigente;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
  }

  saveCategoria() {
    this.clearErrors();
    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._cs.postCategoriaProg(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getCategorias();
              this.popupVisibleAdd = false;
              toastr.success('Datos guardados correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });

      }
      else {
        this._cs.putCategoriaProg(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getCategorias();
              this.popupVisibleAdd = false;
              toastr.success('Datos guardados correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.fuenteId = id;
    this.popupVisibleDel = true;
  }

  deleteCategoria() {
    this._cs.deleteCategoriaProg(this.fuenteId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getCategorias();
          this.popupVisibleDel = false;
          toastr.success('Proceso realizado correctamente.');
        } else {
          toastr.warning(result.data);
        }
      },
      (error) => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.categoria, 'text')) {
      this.hasError.categoria = true; res = false;
    }
    if (!UtilHelper.validator(data.codigo, 'text')) {
      this.hasError.codigo = true; res = false;
    }
    if (!UtilHelper.validator(data.tipo_gasto_id, 'text')) {
      this.hasError.tipo_gasto_id = true; res = false;
    }
    if (!UtilHelper.validator(data.intervencion_id, 'text')) {
      this.hasError.intervencion_id = true; res = false;
    }
  
    return res;
  }
}
